import { render, staticRenderFns } from "./employer-payments.vue?vue&type=template&id=1fb8f6a2&scoped=true"
import script from "./employer-payments.vue?vue&type=script&lang=js"
export * from "./employer-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8f6a2",
  null
  
)

export default component.exports